// Module
var code = "<article class=\"sw-main-menu\" ng-transclude></article> ";
// Exports
export default code;